import type {
	AuditEventActor,
	DocumentSigningRoleType,
	UserSession,
} from '@dealstack/shared/lib/backendClient';

const SYNTHETIC_SESSION_IP = 'system';

const PUBLIC_SIGNER_ROLE_LABELS: Partial<Record<DocumentSigningRoleType, string>> = {
	WITNESS: 'Witness',
	REPRESENTATIVE: 'Representative',
};

export const isSyntheticSession = (userSession: UserSession): boolean =>
	userSession.ipAddress === SYNTHETIC_SESSION_IP;

export const formatBrowserInfo = (userSession: UserSession | null): string => {
	if (!userSession || isSyntheticSession(userSession)) {
		return '';
	}

	return [userSession.browserName, userSession.browserVersion, userSession.osName]
		.filter((part) => part !== undefined && part !== null && part.trim() !== '')
		.join(', ');
};

export const resolveActor = (actor: AuditEventActor): string => {
	if (actor.userSession) {
		// Both name parts are nullable; drop the blanks rather than rendering "null null".
		const { firstName, lastName } = actor.userSession.user;
		return [firstName, lastName].filter(Boolean).join(' ');
	}
	const publicSigner = actor.publicSigner;
	if (!publicSigner) {
		return '';
	}
	if (publicSigner.fullName) {
		return publicSigner.fullName;
	}
	const roleLabel =
		(publicSigner.role && PUBLIC_SIGNER_ROLE_LABELS[publicSigner.role]) || 'External signer';
	return publicSigner.email ? `${roleLabel} (${publicSigner.email})` : roleLabel;
};
